import { default as _91_46_46_46slug_93wShJ1e5x4SMeta } from "/workspace/.app/pages/[...slug].vue?macro=true";
import { default as _91id_93JIDFkP8ekeMeta } from "/workspace/.app/pages/@[influencer]/campanha/[id].vue?macro=true";
import { default as indexM9d6SItogcMeta } from "/workspace/.app/pages/@[influencer]/index.vue?macro=true";
import { default as midia_45kitDpLO4VzlJYMeta } from "/workspace/.app/pages/@[influencer]/midia-kit.vue?macro=true";
import { default as _24KlYoTUQQbMeta } from "/workspace/.app/pages/@[influencer]/parceria/[company]/2.vue?macro=true";
import { default as _3E42x50QQrFMeta } from "/workspace/.app/pages/@[influencer]/parceria/[company]/3.vue?macro=true";
import { default as _4uxdwecsmG2Meta } from "/workspace/.app/pages/@[influencer]/parceria/[company]/4.vue?macro=true";
import { default as indexZ4fMvwzlROMeta } from "/workspace/.app/pages/@[influencer]/parceria/[company]/index.vue?macro=true";
import { default as _91company_93ugZ1pRwK1XMeta } from "/workspace/.app/pages/@[influencer]/parceria/[company].vue?macro=true";
import { default as convites3xEptjMIzlMeta } from "/workspace/.app/pages/app/campanhas/[i]/convites.vue?macro=true";
import { default as _2Ob35MvxlMnMeta } from "/workspace/.app/pages/app/campanhas/[id]/2.vue?macro=true";
import { default as _3Y2useDmWbGMeta } from "/workspace/.app/pages/app/campanhas/[id]/3.vue?macro=true";
import { default as _4cnp3GSkZhJMeta } from "/workspace/.app/pages/app/campanhas/[id]/4.vue?macro=true";
import { default as _5ESlWcD0xy8Meta } from "/workspace/.app/pages/app/campanhas/[id]/5.vue?macro=true";
import { default as _6VpNKSrL86gMeta } from "/workspace/.app/pages/app/campanhas/[id]/6.vue?macro=true";
import { default as _76wVws8SPTgMeta } from "/workspace/.app/pages/app/campanhas/[id]/7.vue?macro=true";
import { default as _858pGAdAsBeMeta } from "/workspace/.app/pages/app/campanhas/[id]/8.vue?macro=true";
import { default as indexxkLLEOpeE9Meta } from "/workspace/.app/pages/app/campanhas/[id]/index.vue?macro=true";
import { default as _91id_93fSIwjI3Bf8Meta } from "/workspace/.app/pages/app/campanhas/[id].vue?macro=true";
import { default as index48nDWee269Meta } from "/workspace/.app/pages/app/campanhas/index.vue?macro=true";
import { default as afiliadoITTdrUDbSpMeta } from "/workspace/.app/pages/app/configuracoes/afiliado.vue?macro=true";
import { default as confirmadoqftpgRWVgWMeta } from "/workspace/.app/pages/app/configuracoes/assinatura/[hash]/confirmado.vue?macro=true";
import { default as expirado4LI4KFYqGdMeta } from "/workspace/.app/pages/app/configuracoes/assinatura/[hash]/expirado.vue?macro=true";
import { default as _91id_93fLmPIxlh2QMeta } from "/workspace/.app/pages/app/configuracoes/assinatura/faturas/[id].vue?macro=true";
import { default as indexsU8X2T2rAiMeta } from "/workspace/.app/pages/app/configuracoes/assinatura/index.vue?macro=true";
import { default as empresaqwclByUAQxMeta } from "/workspace/.app/pages/app/configuracoes/empresa.vue?macro=true";
import { default as equipeMUZJBBRzeXMeta } from "/workspace/.app/pages/app/configuracoes/equipe.vue?macro=true";
import { default as integracoesvBBoztuaI8Meta } from "/workspace/.app/pages/app/configuracoes/integracoes.vue?macro=true";
import { default as notificacoesIYywBlqKu9Meta } from "/workspace/.app/pages/app/configuracoes/notificacoes.vue?macro=true";
import { default as perfilvUlZKRqczUMeta } from "/workspace/.app/pages/app/configuracoes/perfil.vue?macro=true";
import { default as conviteTLa1fwoL06Meta } from "/workspace/.app/pages/app/convite.vue?macro=true";
import { default as financeiroXhYNLKDXR3Meta } from "/workspace/.app/pages/app/dashboards/financeiro.vue?macro=true";
import { default as homeaiGxx1Pa54Meta } from "/workspace/.app/pages/app/dashboards/home.vue?macro=true";
import { default as downloadVEOLsceQb0Meta } from "/workspace/.app/pages/app/download.vue?macro=true";
import { default as biov80AtDbup5Meta } from "/workspace/.app/pages/app/encontrar/instagram/bio.vue?macro=true";
import { default as concorrentesiyibRq4PtwMeta } from "/workspace/.app/pages/app/encontrar/instagram/concorrentes.vue?macro=true";
import { default as hashtagsyWXR1htb76Meta } from "/workspace/.app/pages/app/encontrar/instagram/hashtags.vue?macro=true";
import { default as relacionadosOK5Nmb2uoEMeta } from "/workspace/.app/pages/app/encontrar/instagram/relacionados.vue?macro=true";
import { default as feedbackBsYbhpfbqUMeta } from "/workspace/.app/pages/app/feedback.vue?macro=true";
import { default as _91id_93q5lr5qohbgMeta } from "/workspace/.app/pages/app/influenciadores/abordagens/[id].vue?macro=true";
import { default as index16j4FoG6JCMeta } from "/workspace/.app/pages/app/influenciadores/abordagens/index.vue?macro=true";
import { default as descartados3ad4uWCaXGMeta } from "/workspace/.app/pages/app/influenciadores/descartados.vue?macro=true";
import { default as _91id_93xtWG1iY9eQMeta } from "/workspace/.app/pages/app/influenciadores/listas/[id].vue?macro=true";
import { default as indexPFQ6aYn5lpMeta } from "/workspace/.app/pages/app/influenciadores/listas/index.vue?macro=true";
import { default as unsubscribeawadgZL9gnMeta } from "/workspace/.app/pages/app/unsubscribe.vue?macro=true";
import { default as loginkRZqKWTWfmMeta } from "/workspace/.app/pages/auth/login.vue?macro=true";
import { default as password_45recoverBMNuriz73oMeta } from "/workspace/.app/pages/auth/password-recover.vue?macro=true";
import { default as _91token_93rpy4kH6c22Meta } from "/workspace/.app/pages/auth/password-reset/[token].vue?macro=true";
import { default as registerfeFcS9lHAwMeta } from "/workspace/.app/pages/auth/register.vue?macro=true";
import { default as two_45factor_45challengeBSDOx7Uzk5Meta } from "/workspace/.app/pages/auth/two-factor-challenge.vue?macro=true";
import { default as comissoesSortCNxLIIMeta } from "/workspace/.app/pages/influenciador/comissoes.vue?macro=true";
import { default as indexXtSrOQhiYAMeta } from "/workspace/.app/pages/influenciador/index.vue?macro=true";
import { default as link_45viralS8tJ1IQPQQMeta } from "/workspace/.app/pages/influenciador/link-viral.vue?macro=true";
import { default as midia_45kitanzOMfjaj8Meta } from "/workspace/.app/pages/influenciador/midia-kit.vue?macro=true";
import { default as parceriasslI4trD5XOMeta } from "/workspace/.app/pages/influenciador/parcerias.vue?macro=true";
import { default as preferenciasrKv6583XgJMeta } from "/workspace/.app/pages/influenciador/preferencias.vue?macro=true";
import { default as politica_45de_45privacidadeL7a0gQzWBjMeta } from "/workspace/.app/pages/politica-de-privacidade.vue?macro=true";
import { default as _91ref_93XLFg2EM6h0Meta } from "/workspace/.app/pages/ref/[ref].vue?macro=true";
import { default as termos_45de_45servico2sfKWCrQr6Meta } from "/workspace/.app/pages/termos-de-servico.vue?macro=true";
import { default as component_45stub6W70TAg7LzMeta } from "/workspace/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.4.1_@types+node@22.5.0_eslint@8.57.0_ioredis@5.4.1_magicast@0.3_r7zvup4677zgjtac4gtbjsydkm/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub6W70TAg7Lz } from "/workspace/node_modules/.pnpm/nuxt@3.13.0_@parcel+watcher@2.4.1_@types+node@22.5.0_eslint@8.57.0_ioredis@5.4.1_magicast@0.3_r7zvup4677zgjtac4gtbjsydkm/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___br",
    path: "/:slug(.*)*",
    component: () => import("/workspace/.app/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/workspace/.app/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "@influencer-campanha-id___br",
    path: "/@:influencer()/campanha/:id()",
    meta: _91id_93JIDFkP8ekeMeta || {},
    component: () => import("/workspace/.app/pages/@[influencer]/campanha/[id].vue").then(m => m.default || m)
  },
  {
    name: "@influencer-campanha-id___en",
    path: "/en/@:influencer()/campanha/:id()",
    meta: _91id_93JIDFkP8ekeMeta || {},
    component: () => import("/workspace/.app/pages/@[influencer]/campanha/[id].vue").then(m => m.default || m)
  },
  {
    name: "@influencer___br",
    path: "/@:influencer()",
    meta: indexM9d6SItogcMeta || {},
    component: () => import("/workspace/.app/pages/@[influencer]/index.vue").then(m => m.default || m)
  },
  {
    name: "@influencer___en",
    path: "/en/@:influencer()",
    meta: indexM9d6SItogcMeta || {},
    component: () => import("/workspace/.app/pages/@[influencer]/index.vue").then(m => m.default || m)
  },
  {
    name: "@influencer-midia-kit___br",
    path: "/@:influencer()/midia-kit",
    component: () => import("/workspace/.app/pages/@[influencer]/midia-kit.vue").then(m => m.default || m)
  },
  {
    name: "@influencer-midia-kit___en",
    path: "/en/@:influencer()/midia-kit",
    component: () => import("/workspace/.app/pages/@[influencer]/midia-kit.vue").then(m => m.default || m)
  },
  {
    name: _91company_93ugZ1pRwK1XMeta?.name,
    path: "/@:influencer()/parceria/:company()",
    meta: _91company_93ugZ1pRwK1XMeta || {},
    component: () => import("/workspace/.app/pages/@[influencer]/parceria/[company].vue").then(m => m.default || m),
    children: [
  {
    name: "@influencer-parceria-company-2___br",
    path: "2",
    component: () => import("/workspace/.app/pages/@[influencer]/parceria/[company]/2.vue").then(m => m.default || m)
  },
  {
    name: "@influencer-parceria-company-3___br",
    path: "3",
    component: () => import("/workspace/.app/pages/@[influencer]/parceria/[company]/3.vue").then(m => m.default || m)
  },
  {
    name: "@influencer-parceria-company-4___br",
    path: "4",
    component: () => import("/workspace/.app/pages/@[influencer]/parceria/[company]/4.vue").then(m => m.default || m)
  },
  {
    name: "@influencer-parceria-company___br",
    path: "",
    component: () => import("/workspace/.app/pages/@[influencer]/parceria/[company]/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: _91company_93ugZ1pRwK1XMeta?.name,
    path: "/en/@:influencer()/parceria/:company()",
    meta: _91company_93ugZ1pRwK1XMeta || {},
    component: () => import("/workspace/.app/pages/@[influencer]/parceria/[company].vue").then(m => m.default || m),
    children: [
  {
    name: "@influencer-parceria-company-2___en",
    path: "2",
    component: () => import("/workspace/.app/pages/@[influencer]/parceria/[company]/2.vue").then(m => m.default || m)
  },
  {
    name: "@influencer-parceria-company-3___en",
    path: "3",
    component: () => import("/workspace/.app/pages/@[influencer]/parceria/[company]/3.vue").then(m => m.default || m)
  },
  {
    name: "@influencer-parceria-company-4___en",
    path: "4",
    component: () => import("/workspace/.app/pages/@[influencer]/parceria/[company]/4.vue").then(m => m.default || m)
  },
  {
    name: "@influencer-parceria-company___en",
    path: "",
    component: () => import("/workspace/.app/pages/@[influencer]/parceria/[company]/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "app-campanhas-i-convites___br",
    path: "/app/campanhas/:i()/convites",
    meta: convites3xEptjMIzlMeta || {},
    component: () => import("/workspace/.app/pages/app/campanhas/[i]/convites.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-i-convites___en",
    path: "/en/app/campanhas/:i()/convites",
    meta: convites3xEptjMIzlMeta || {},
    component: () => import("/workspace/.app/pages/app/campanhas/[i]/convites.vue").then(m => m.default || m)
  },
  {
    name: _91id_93fSIwjI3Bf8Meta?.name,
    path: "/app/campanhas/:id()",
    meta: _91id_93fSIwjI3Bf8Meta || {},
    component: () => import("/workspace/.app/pages/app/campanhas/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "app-campanhas-id-2___br",
    path: "2",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/2.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id-3___br",
    path: "3",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/3.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id-4___br",
    path: "4",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/4.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id-5___br",
    path: "5",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/5.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id-6___br",
    path: "6",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/6.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id-7___br",
    path: "7",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/7.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id-8___br",
    path: "8",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/8.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id___br",
    path: "",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: _91id_93fSIwjI3Bf8Meta?.name,
    path: "/en/app/campanhas/:id()",
    meta: _91id_93fSIwjI3Bf8Meta || {},
    component: () => import("/workspace/.app/pages/app/campanhas/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "app-campanhas-id-2___en",
    path: "2",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/2.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id-3___en",
    path: "3",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/3.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id-4___en",
    path: "4",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/4.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id-5___en",
    path: "5",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/5.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id-6___en",
    path: "6",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/6.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id-7___en",
    path: "7",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/7.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id-8___en",
    path: "8",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/8.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas-id___en",
    path: "",
    component: () => import("/workspace/.app/pages/app/campanhas/[id]/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "app-campanhas___br",
    path: "/app/campanhas",
    meta: index48nDWee269Meta || {},
    component: () => import("/workspace/.app/pages/app/campanhas/index.vue").then(m => m.default || m)
  },
  {
    name: "app-campanhas___en",
    path: "/en/app/campanhas",
    meta: index48nDWee269Meta || {},
    component: () => import("/workspace/.app/pages/app/campanhas/index.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-afiliado___br",
    path: "/app/configuracoes/afiliado",
    meta: afiliadoITTdrUDbSpMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/afiliado.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-afiliado___en",
    path: "/en/app/configuracoes/afiliado",
    meta: afiliadoITTdrUDbSpMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/afiliado.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-assinatura-hash-confirmado___br",
    path: "/app/configuracoes/assinatura/:hash()/confirmado",
    meta: confirmadoqftpgRWVgWMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/assinatura/[hash]/confirmado.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-assinatura-hash-confirmado___en",
    path: "/en/app/configuracoes/assinatura/:hash()/confirmado",
    meta: confirmadoqftpgRWVgWMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/assinatura/[hash]/confirmado.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-assinatura-hash-expirado___br",
    path: "/app/configuracoes/assinatura/:hash()/expirado",
    meta: expirado4LI4KFYqGdMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/assinatura/[hash]/expirado.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-assinatura-hash-expirado___en",
    path: "/en/app/configuracoes/assinatura/:hash()/expirado",
    meta: expirado4LI4KFYqGdMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/assinatura/[hash]/expirado.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-assinatura-faturas-id___br",
    path: "/app/configuracoes/assinatura/faturas/:id()",
    meta: _91id_93fLmPIxlh2QMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/assinatura/faturas/[id].vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-assinatura-faturas-id___en",
    path: "/en/app/configuracoes/assinatura/faturas/:id()",
    meta: _91id_93fLmPIxlh2QMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/assinatura/faturas/[id].vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-assinatura___br",
    path: "/app/configuracoes/assinatura",
    meta: indexsU8X2T2rAiMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/assinatura/index.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-assinatura___en",
    path: "/en/app/configuracoes/assinatura",
    meta: indexsU8X2T2rAiMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/assinatura/index.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-empresa___br",
    path: "/app/configuracoes/empresa",
    meta: empresaqwclByUAQxMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/empresa.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-empresa___en",
    path: "/en/app/configuracoes/empresa",
    meta: empresaqwclByUAQxMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/empresa.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-equipe___br",
    path: "/app/configuracoes/equipe",
    meta: equipeMUZJBBRzeXMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/equipe.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-equipe___en",
    path: "/en/app/configuracoes/equipe",
    meta: equipeMUZJBBRzeXMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/equipe.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-integracoes___br",
    path: "/app/configuracoes/integracoes",
    meta: integracoesvBBoztuaI8Meta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/integracoes.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-integracoes___en",
    path: "/en/app/configuracoes/integracoes",
    meta: integracoesvBBoztuaI8Meta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/integracoes.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-notificacoes___br",
    path: "/app/configuracoes/notificacoes",
    meta: notificacoesIYywBlqKu9Meta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/notificacoes.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-notificacoes___en",
    path: "/en/app/configuracoes/notificacoes",
    meta: notificacoesIYywBlqKu9Meta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/notificacoes.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-perfil___br",
    path: "/app/configuracoes/perfil",
    meta: perfilvUlZKRqczUMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/perfil.vue").then(m => m.default || m)
  },
  {
    name: "app-configuracoes-perfil___en",
    path: "/en/app/configuracoes/perfil",
    meta: perfilvUlZKRqczUMeta || {},
    component: () => import("/workspace/.app/pages/app/configuracoes/perfil.vue").then(m => m.default || m)
  },
  {
    name: "app-convite___br",
    path: "/app/convite",
    meta: conviteTLa1fwoL06Meta || {},
    component: () => import("/workspace/.app/pages/app/convite.vue").then(m => m.default || m)
  },
  {
    name: "app-convite___en",
    path: "/en/app/convite",
    meta: conviteTLa1fwoL06Meta || {},
    component: () => import("/workspace/.app/pages/app/convite.vue").then(m => m.default || m)
  },
  {
    name: "app-dashboards-financeiro___br",
    path: "/app/dashboards/financeiro",
    meta: financeiroXhYNLKDXR3Meta || {},
    component: () => import("/workspace/.app/pages/app/dashboards/financeiro.vue").then(m => m.default || m)
  },
  {
    name: "app-dashboards-financeiro___en",
    path: "/en/app/dashboards/financeiro",
    meta: financeiroXhYNLKDXR3Meta || {},
    component: () => import("/workspace/.app/pages/app/dashboards/financeiro.vue").then(m => m.default || m)
  },
  {
    name: "app-dashboards-home___br",
    path: "/app/dashboards/home",
    meta: homeaiGxx1Pa54Meta || {},
    component: () => import("/workspace/.app/pages/app/dashboards/home.vue").then(m => m.default || m)
  },
  {
    name: "app-dashboards-home___en",
    path: "/en/app/dashboards/home",
    meta: homeaiGxx1Pa54Meta || {},
    component: () => import("/workspace/.app/pages/app/dashboards/home.vue").then(m => m.default || m)
  },
  {
    name: "app-download___br",
    path: "/app/download",
    meta: downloadVEOLsceQb0Meta || {},
    component: () => import("/workspace/.app/pages/app/download.vue").then(m => m.default || m)
  },
  {
    name: "app-download___en",
    path: "/en/app/download",
    meta: downloadVEOLsceQb0Meta || {},
    component: () => import("/workspace/.app/pages/app/download.vue").then(m => m.default || m)
  },
  {
    name: "app-encontrar-instagram-bio___br",
    path: "/app/encontrar/instagram/bio",
    meta: biov80AtDbup5Meta || {},
    component: () => import("/workspace/.app/pages/app/encontrar/instagram/bio.vue").then(m => m.default || m)
  },
  {
    name: "app-encontrar-instagram-bio___en",
    path: "/en/app/encontrar/instagram/bio",
    meta: biov80AtDbup5Meta || {},
    component: () => import("/workspace/.app/pages/app/encontrar/instagram/bio.vue").then(m => m.default || m)
  },
  {
    name: "app-encontrar-instagram-concorrentes___br",
    path: "/app/encontrar/instagram/concorrentes",
    meta: concorrentesiyibRq4PtwMeta || {},
    component: () => import("/workspace/.app/pages/app/encontrar/instagram/concorrentes.vue").then(m => m.default || m)
  },
  {
    name: "app-encontrar-instagram-concorrentes___en",
    path: "/en/app/encontrar/instagram/concorrentes",
    meta: concorrentesiyibRq4PtwMeta || {},
    component: () => import("/workspace/.app/pages/app/encontrar/instagram/concorrentes.vue").then(m => m.default || m)
  },
  {
    name: "app-encontrar-instagram-hashtags___br",
    path: "/app/encontrar/instagram/hashtags",
    meta: hashtagsyWXR1htb76Meta || {},
    component: () => import("/workspace/.app/pages/app/encontrar/instagram/hashtags.vue").then(m => m.default || m)
  },
  {
    name: "app-encontrar-instagram-hashtags___en",
    path: "/en/app/encontrar/instagram/hashtags",
    meta: hashtagsyWXR1htb76Meta || {},
    component: () => import("/workspace/.app/pages/app/encontrar/instagram/hashtags.vue").then(m => m.default || m)
  },
  {
    name: "app-encontrar-instagram-relacionados___br",
    path: "/app/encontrar/instagram/relacionados",
    meta: relacionadosOK5Nmb2uoEMeta || {},
    component: () => import("/workspace/.app/pages/app/encontrar/instagram/relacionados.vue").then(m => m.default || m)
  },
  {
    name: "app-encontrar-instagram-relacionados___en",
    path: "/en/app/encontrar/instagram/relacionados",
    meta: relacionadosOK5Nmb2uoEMeta || {},
    component: () => import("/workspace/.app/pages/app/encontrar/instagram/relacionados.vue").then(m => m.default || m)
  },
  {
    name: "app-feedback___br",
    path: "/app/feedback",
    meta: feedbackBsYbhpfbqUMeta || {},
    component: () => import("/workspace/.app/pages/app/feedback.vue").then(m => m.default || m)
  },
  {
    name: "app-feedback___en",
    path: "/en/app/feedback",
    meta: feedbackBsYbhpfbqUMeta || {},
    component: () => import("/workspace/.app/pages/app/feedback.vue").then(m => m.default || m)
  },
  {
    name: "app-influenciadores-abordagens-id___br",
    path: "/app/influenciadores/abordagens/:id()",
    meta: _91id_93q5lr5qohbgMeta || {},
    component: () => import("/workspace/.app/pages/app/influenciadores/abordagens/[id].vue").then(m => m.default || m)
  },
  {
    name: "app-influenciadores-abordagens-id___en",
    path: "/en/app/influenciadores/abordagens/:id()",
    meta: _91id_93q5lr5qohbgMeta || {},
    component: () => import("/workspace/.app/pages/app/influenciadores/abordagens/[id].vue").then(m => m.default || m)
  },
  {
    name: "app-influenciadores-abordagens___br",
    path: "/app/influenciadores/abordagens",
    meta: index16j4FoG6JCMeta || {},
    component: () => import("/workspace/.app/pages/app/influenciadores/abordagens/index.vue").then(m => m.default || m)
  },
  {
    name: "app-influenciadores-abordagens___en",
    path: "/en/app/influenciadores/abordagens",
    meta: index16j4FoG6JCMeta || {},
    component: () => import("/workspace/.app/pages/app/influenciadores/abordagens/index.vue").then(m => m.default || m)
  },
  {
    name: "app-influenciadores-descartados___br",
    path: "/app/influenciadores/descartados",
    meta: descartados3ad4uWCaXGMeta || {},
    component: () => import("/workspace/.app/pages/app/influenciadores/descartados.vue").then(m => m.default || m)
  },
  {
    name: "app-influenciadores-descartados___en",
    path: "/en/app/influenciadores/descartados",
    meta: descartados3ad4uWCaXGMeta || {},
    component: () => import("/workspace/.app/pages/app/influenciadores/descartados.vue").then(m => m.default || m)
  },
  {
    name: "app-influenciadores-listas-id___br",
    path: "/app/influenciadores/listas/:id()",
    meta: _91id_93xtWG1iY9eQMeta || {},
    component: () => import("/workspace/.app/pages/app/influenciadores/listas/[id].vue").then(m => m.default || m)
  },
  {
    name: "app-influenciadores-listas-id___en",
    path: "/en/app/influenciadores/listas/:id()",
    meta: _91id_93xtWG1iY9eQMeta || {},
    component: () => import("/workspace/.app/pages/app/influenciadores/listas/[id].vue").then(m => m.default || m)
  },
  {
    name: "app-influenciadores-listas___br",
    path: "/app/influenciadores/listas",
    meta: indexPFQ6aYn5lpMeta || {},
    component: () => import("/workspace/.app/pages/app/influenciadores/listas/index.vue").then(m => m.default || m)
  },
  {
    name: "app-influenciadores-listas___en",
    path: "/en/app/influenciadores/listas",
    meta: indexPFQ6aYn5lpMeta || {},
    component: () => import("/workspace/.app/pages/app/influenciadores/listas/index.vue").then(m => m.default || m)
  },
  {
    name: "app-unsubscribe___br",
    path: "/app/unsubscribe",
    component: () => import("/workspace/.app/pages/app/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: "app-unsubscribe___en",
    path: "/en/app/unsubscribe",
    component: () => import("/workspace/.app/pages/app/unsubscribe.vue").then(m => m.default || m)
  },
  {
    name: "auth-login___br",
    path: "/auth/login",
    meta: loginkRZqKWTWfmMeta || {},
    component: () => import("/workspace/.app/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: "auth-login___en",
    path: "/en/auth/login",
    meta: loginkRZqKWTWfmMeta || {},
    component: () => import("/workspace/.app/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: "auth-password-recover___br",
    path: "/auth/password-recover",
    meta: password_45recoverBMNuriz73oMeta || {},
    component: () => import("/workspace/.app/pages/auth/password-recover.vue").then(m => m.default || m)
  },
  {
    name: "auth-password-recover___en",
    path: "/en/auth/password-recover",
    meta: password_45recoverBMNuriz73oMeta || {},
    component: () => import("/workspace/.app/pages/auth/password-recover.vue").then(m => m.default || m)
  },
  {
    name: "auth-password-reset-token___br",
    path: "/auth/password-reset/:token()",
    meta: _91token_93rpy4kH6c22Meta || {},
    component: () => import("/workspace/.app/pages/auth/password-reset/[token].vue").then(m => m.default || m)
  },
  {
    name: "auth-password-reset-token___en",
    path: "/en/auth/password-reset/:token()",
    meta: _91token_93rpy4kH6c22Meta || {},
    component: () => import("/workspace/.app/pages/auth/password-reset/[token].vue").then(m => m.default || m)
  },
  {
    name: "auth-register___br",
    path: "/auth/register",
    meta: registerfeFcS9lHAwMeta || {},
    component: () => import("/workspace/.app/pages/auth/register.vue").then(m => m.default || m)
  },
  {
    name: "auth-register___en",
    path: "/en/auth/register",
    meta: registerfeFcS9lHAwMeta || {},
    component: () => import("/workspace/.app/pages/auth/register.vue").then(m => m.default || m)
  },
  {
    name: "auth-two-factor-challenge___br",
    path: "/auth/two-factor-challenge",
    meta: two_45factor_45challengeBSDOx7Uzk5Meta || {},
    component: () => import("/workspace/.app/pages/auth/two-factor-challenge.vue").then(m => m.default || m)
  },
  {
    name: "auth-two-factor-challenge___en",
    path: "/en/auth/two-factor-challenge",
    meta: two_45factor_45challengeBSDOx7Uzk5Meta || {},
    component: () => import("/workspace/.app/pages/auth/two-factor-challenge.vue").then(m => m.default || m)
  },
  {
    name: "influenciador-comissoes___br",
    path: "/influenciador/comissoes",
    meta: comissoesSortCNxLIIMeta || {},
    component: () => import("/workspace/.app/pages/influenciador/comissoes.vue").then(m => m.default || m)
  },
  {
    name: "influenciador-comissoes___en",
    path: "/en/influenciador/comissoes",
    meta: comissoesSortCNxLIIMeta || {},
    component: () => import("/workspace/.app/pages/influenciador/comissoes.vue").then(m => m.default || m)
  },
  {
    name: "influenciador___br",
    path: "/influenciador",
    meta: indexXtSrOQhiYAMeta || {},
    component: () => import("/workspace/.app/pages/influenciador/index.vue").then(m => m.default || m)
  },
  {
    name: "influenciador___en",
    path: "/en/influenciador",
    meta: indexXtSrOQhiYAMeta || {},
    component: () => import("/workspace/.app/pages/influenciador/index.vue").then(m => m.default || m)
  },
  {
    name: "influenciador-link-viral___br",
    path: "/influenciador/link-viral",
    meta: link_45viralS8tJ1IQPQQMeta || {},
    component: () => import("/workspace/.app/pages/influenciador/link-viral.vue").then(m => m.default || m)
  },
  {
    name: "influenciador-link-viral___en",
    path: "/en/influenciador/link-viral",
    meta: link_45viralS8tJ1IQPQQMeta || {},
    component: () => import("/workspace/.app/pages/influenciador/link-viral.vue").then(m => m.default || m)
  },
  {
    name: "influenciador-midia-kit___br",
    path: "/influenciador/midia-kit",
    meta: midia_45kitanzOMfjaj8Meta || {},
    component: () => import("/workspace/.app/pages/influenciador/midia-kit.vue").then(m => m.default || m)
  },
  {
    name: "influenciador-midia-kit___en",
    path: "/en/influenciador/midia-kit",
    meta: midia_45kitanzOMfjaj8Meta || {},
    component: () => import("/workspace/.app/pages/influenciador/midia-kit.vue").then(m => m.default || m)
  },
  {
    name: "influenciador-parcerias___br",
    path: "/influenciador/parcerias",
    meta: parceriasslI4trD5XOMeta || {},
    component: () => import("/workspace/.app/pages/influenciador/parcerias.vue").then(m => m.default || m)
  },
  {
    name: "influenciador-parcerias___en",
    path: "/en/influenciador/parcerias",
    meta: parceriasslI4trD5XOMeta || {},
    component: () => import("/workspace/.app/pages/influenciador/parcerias.vue").then(m => m.default || m)
  },
  {
    name: "influenciador-preferencias___br",
    path: "/influenciador/preferencias",
    meta: preferenciasrKv6583XgJMeta || {},
    component: () => import("/workspace/.app/pages/influenciador/preferencias.vue").then(m => m.default || m)
  },
  {
    name: "influenciador-preferencias___en",
    path: "/en/influenciador/preferencias",
    meta: preferenciasrKv6583XgJMeta || {},
    component: () => import("/workspace/.app/pages/influenciador/preferencias.vue").then(m => m.default || m)
  },
  {
    name: "politica-de-privacidade___br",
    path: "/politica-de-privacidade",
    meta: politica_45de_45privacidadeL7a0gQzWBjMeta || {},
    component: () => import("/workspace/.app/pages/politica-de-privacidade.vue").then(m => m.default || m)
  },
  {
    name: "politica-de-privacidade___en",
    path: "/en/privacy-policy",
    meta: politica_45de_45privacidadeL7a0gQzWBjMeta || {},
    component: () => import("/workspace/.app/pages/politica-de-privacidade.vue").then(m => m.default || m)
  },
  {
    name: "ref-ref___br",
    path: "/ref/:ref()",
    component: () => import("/workspace/.app/pages/ref/[ref].vue").then(m => m.default || m)
  },
  {
    name: "ref-ref___en",
    path: "/en/ref/:ref()",
    component: () => import("/workspace/.app/pages/ref/[ref].vue").then(m => m.default || m)
  },
  {
    name: "termos-de-servico___br",
    path: "/termos-de-servico",
    meta: termos_45de_45servico2sfKWCrQr6Meta || {},
    component: () => import("/workspace/.app/pages/termos-de-servico.vue").then(m => m.default || m)
  },
  {
    name: "termos-de-servico___en",
    path: "/en/terms-of-service",
    meta: termos_45de_45servico2sfKWCrQr6Meta || {},
    component: () => import("/workspace/.app/pages/termos-de-servico.vue").then(m => m.default || m)
  },
  {
    name: component_45stub6W70TAg7LzMeta?.name,
    path: "/app/pesquisar/similares",
    component: component_45stub6W70TAg7Lz
  },
  {
    name: component_45stub6W70TAg7LzMeta?.name,
    path: "/app/pesquisar/palavras-na-bio",
    component: component_45stub6W70TAg7Lz
  },
  {
    name: component_45stub6W70TAg7LzMeta?.name,
    path: "/app/pesquisar/concorrentes",
    component: component_45stub6W70TAg7Lz
  },
  {
    name: component_45stub6W70TAg7LzMeta?.name,
    path: "/app/pesquisar/hashtags",
    component: component_45stub6W70TAg7Lz
  },
  {
    name: component_45stub6W70TAg7LzMeta?.name,
    path: "/app/pesquisar/instagram/similares",
    component: component_45stub6W70TAg7Lz
  },
  {
    name: component_45stub6W70TAg7LzMeta?.name,
    path: "/app/pesquisar/instagram/palavras-na-bio",
    component: component_45stub6W70TAg7Lz
  },
  {
    name: component_45stub6W70TAg7LzMeta?.name,
    path: "/app/pesquisar/instagram/concorrentes",
    component: component_45stub6W70TAg7Lz
  },
  {
    name: component_45stub6W70TAg7LzMeta?.name,
    path: "/app/pesquisar/instagram/hashtags",
    component: component_45stub6W70TAg7Lz
  },
  {
    name: component_45stub6W70TAg7LzMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub6W70TAg7Lz
  },
  {
    name: component_45stub6W70TAg7LzMeta?.name,
    path: "/index-sitemap.xml",
    component: component_45stub6W70TAg7Lz
  },
  {
    name: component_45stub6W70TAg7LzMeta?.name,
    path: "/br-sitemap.xml",
    component: component_45stub6W70TAg7Lz
  },
  {
    name: component_45stub6W70TAg7LzMeta?.name,
    path: "/en-sitemap.xml",
    component: component_45stub6W70TAg7Lz
  }
]